import { Sprinkles, sprinkles } from '@/styles/sprinkles.css'

export function isSprinkleProp(prop: string): prop is keyof Sprinkles {
  return sprinkles.properties.has(prop as any)
}
